<template>
 <div :class="windowClass">
   <v-container>
    <v-row>
      <v-col cols="12">
                <v-card>
               <v-toolbar>
                 <v-icon left color="primary">mdi-handshake</v-icon> Pay Partners
                 <v-spacer/>
                 <span style="width: 290px;">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            dense
                            outlined
                            hide-details
                        ></v-text-field>
                 </span>
                 <v-divider vertical inset class="ml-5 mr-2"/>
                        <v-btn text v-if="ALLOW('add_franchise')" small color="success"  @click="selecteditem={}, state='new', form=true"><v-icon small left color="success">mdi-plus</v-icon>  New</v-btn>
               </v-toolbar>
               <v-card-text>
                <v-data-table
                    class="va-table"
                    dense
                    :headers="headers"
                    :search="search"
                    :items="items"
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                            <td>
                            <v-icon  x-small left color="warning" @click="selectedID=item.id, state='update', form=true" >mdi-pencil</v-icon>
                            {{ item.company }}</td>
                            <td>{{ item.contact_person }}</td>
                            <td>{{ item.contact_no }}</td>
                            <td>{{ item.area }}</td>
                            <td>{{ $moment(item.created_dt).format("MMM, DD YYYY hh:mm A") }}</td>
                             <td :class="STATUS_COLOR(item.status)">{{ item.status }}</td>
                              <td class="text-right">{{ $money(item.wallet) }}</td>
                        </tr>
                        </tbody>
                    </template>
                    </v-data-table>
               </v-card-text>
             </v-card>
          </v-col>
         
    </v-row>
    </v-container>
     <va-franchisee-form :show="form" :selectedID="selectedID"  :state="state" @DialogEvent="formEvent" />
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
        form: false,
        search:"",
        selectedID:  null,
        trans_dailog: false,
        areaform: false,
        state: 'new',
        items:[],
        headers: [
          { text: 'Name', value:"name"},
            { text: 'Category', value:"category"},
            { text: 'code.', value:"contact_no"},
            { text: 'Status', value:"status"},
            { text: 'Created' },
        ]
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
           this.$partner.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.getItems()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
    
      formEvent(){
          this.form = false
          this.getItems()
      },

      
      getItems: function() { 
        this.$partner.get("partner/list").then(response => {
            response.data.list != null?this.items = response.data.list:this.items =[]
        }).catch(e => {
        console.log(e.data)
        })
     }
    }
  }
</script>